import type { TooltipDesignTokens, TooltipTokenSections } from '@openng/optimus-ui-themes/types/tooltip';

export const root: TooltipTokenSections.Root = {
	maxWidth: '28.125rem',
	gutter: '0.5rem',
	shadow: '0 0.125rem 0.5rem rgba(0, 0, 0, 0.2)',
	padding: '1rem',
	borderRadius: '{border.radius.md}',
};

export const colorScheme: TooltipTokenSections.ColorScheme = {
	light: {
		root: {
			background: '{primary.600}',
			color: '{primary.contrast.color}',
		},
	},
};

export default {
	root,
	colorScheme,
} satisfies TooltipDesignTokens;
